import { Controller } from '@hotwired/stimulus'
import openModal from '../utils/modal'

export default class extends Controller {
  call (event) {
    event.preventDefault()

    let { behavior, href, modalVariant: variant, slug, suffix, type } = this.element.dataset

    let url = this.element.getAttribute('href') || href
    url = suffix ? `${url}/${suffix}` : url

    if (type === 'organization' || type === 'proofpoint' || type === 'connection') {
      behavior = 'drawer'
      variant = 'small'
    }
    const opts = { behavior, slug, url, variant }
    console.debug('[modal_trigger_controller] calling openModal', opts)
    openModal(opts)
  }
}
